<mat-card id="cliente-movimentacao-rv">
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>
            <span>
                Movimentação Histórica de Operações Renda Variável
            </span> 

            <div>
                <button 
                    mat-mini-fab                                        
                    *ngIf="data != null && data != undefined" 
                    matTooltip="Inserir Histórico"
                    (click)="openCadastro()">                                        
                    <mat-icon>add</mat-icon>
                </button>
    
                <button 
                    mat-mini-fab
                    style=" margin-left: 10px"
                    *ngIf="data != null && data != undefined" 
                    matTooltip="Filtrar Histórico"
                    (click)="openFiltro()">
                    <mat-icon>search</mat-icon>
                </button>
    
                <button 
                    mat-mini-fab
                    style=" margin-left: 10px"
                    *ngIf="user.role_id == 2 || user.role_id == 4 || user.role_id == 7" 
                    matTooltip="Importar Histórico"
                    (click)="openUpload()">
                    <mat-icon>cloud_upload</mat-icon>
                </button>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <p>Data da Última Atualização:  <b>{{data_atualizacao | date:'dd/MM/yyyy'}} </b> </p> 
            <p>
               <legenda-estrategias-rv 
                    [cliente_id]="data"
                    [tipo]="'MOVIMENTACAO'"
                ></legenda-estrategias-rv>
            </p>
        </mat-card-subtitle>
        
    </mat-card-header>

    <mat-card-content>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'" 
            [rows]='rows'
            [limit]="params.per_page"
            (sort)="onSort($event)"           
        >       

            <ngx-datatable-column name="Data" prop="created_at" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                    {{created_at | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column name="ATIVO" prop="ativo" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span 
                        style="padding: 5px; border-radius: 10px;" 
                        [className]="row.cor_hexadecimal"
                    >
                        <b>{{row.sigla_ativo}}</b>
                    </span>
                </ng-template>
            </ngx-datatable-column>
                                           
            <ngx-datatable-column name="Operação" prop="tipo" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ getOperacao(row) }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Tipo" prop="tipo_ativo" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span matTooltip= "Ações, BDRs, ETDs, FIIs e Units">
                        {{ getTipoAtivo(row) }}
                    </span>                    
                    
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Qtd. Exec" prop="qtd_executado" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{  row.tipo.trim() != 'D' ? (row.qtd_executado | number : '1.0-0') : '--' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Preço (R$)" prop="preco_executado" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.tipo.trim() != 'E' && row.tipo.trim() != 'D' ? (row.preco_executado | number : '1.2-2') : '--'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Valor Financeiro (R$)" prop="volume_inicial" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span                         
                        [ngClass]="{
                            'negativo': row.tipo.trim() === 'C', 
                            'positivo': row.tipo.trim() === 'V',
                            'credito': row.tipo.trim() === 'D'
                        }"
                    >
                        {{ row.tipo.trim() != 'E' ? (getPrecoExecutado(row) | number : '1.2-2') : '--' }} 
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ações" prop="id" [sortable]="false">                                            
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button 
                        mat-icon-button 
                        color="warn" 
                        matTooltip="Excluir histórico do cliente" 
                        (click)="delete(row.id)" 
                        *ngIf="row.tipo_inclusao == 'M' || row.tipo_inclusao == 'I' "
                    >
                        <mat-icon 
                            aria-label="Excluir histórico do cliente"
                        >
                            delete
                        </mat-icon>
                    </button>
                    
                    <button 
                        mat-icon-button 
                        matTooltip="Alterar histórico do cliente" 
                        (click)="alterar(row.id)"
                    >
                        <mat-icon aria-label="Alterar histórico do cliente">edit</mat-icon>
                    </button>                                
                </ng-template>
            </ngx-datatable-column>

        </ngx-datatable>

        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginatorMovimentacao 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>